export const awards = [
        {
            title: 'IEEE Canada J. M. Ham Outstanding Engineering Educator Silver Medal Award',
            date: '2026',
            text: '',
            link: ''
        },
        {
            title: 'Engineering Excellence Award, Professional Engineers Ontario (PEO)-Ottawa Chapter',
            date: '2026',
            text: '',
            link: ''
        },
        {
            title: 'IEEE Ottawa Section Outstanding Engineering Educator Award',
            date: '2025',
            text: '',
            link: ''
        },
        {
            title: 'King Charles III Coronation Medal',
            date: '2025',
            text: '',
            link: ''
        },
        {
            title: 'George S. Glinski Award for Excellence in Research',
            date: '2025',
            text: 'Faculty of Engineering, University of Ottawa (2024-2025)',
            link: ''
        },
        {
            title: 'IEEE ComSoc Communications Systems Integration and Modeling (CSIM) TC Best Journal Paper Award',
            date: '2024',
            text: 'M. A. Ferrag, O. Friha, B. Kantarci, N. Tihanyi, L. Cordeiro, M. Debbah, D. Hamouda, M. Al-Hawawreh, K-K. Raymond Choo, "Edge Learning for 6G-enabled Internet of Things: A Comprehensive Survey of Vulnerabilities, Datasets, and Defenses," IEEE Communications Surveys and Tutorials, vol, 25, issue 4, pp. 2654 2713, Fourth Quarter 2023',
            link: ''
        },
        {
            title: 'IEEE Globecom 2024 Best Paper Award',
            date: '2024',
            text: 'M. A. Onsu, P. Lohan, B. Kantarci, E. Janulewicz, S. Slobodrian, "A New Realistic Platform for Benchmarking and Performance Evaluation of DRL-Driven and Reconfigurable SFC Provisioning Solutions," IEEE Globecom 2024',
            link: ''
        },
        {
            title: 'IEEE Communications Software Technical Committee 2023 Technical Achievement Award',
            date: '2024',
            text: '“for contributions to AI/ML-enabled communication network security and trustworthy sensing systems for the Internet of Things”',
            link: ''
        },
        {
            title: 'IEEE VCC 2023 Best Student Paper Award',
            date: '2023',
            text: 'A. Omara, B. Kantarci,  "Generative Adversarial Networks to Secure Vehicle-to-Microgrid Services," IEEE Virtual Conference on Communications (VCC), Nov. 2023',
            link: ''
        },
        {
            title: 'IEEE ICC 2023 Best Paper Award',
            date: '2023',
            text: 'P. E. Itturria Rivera, M. Chenier, B. Herscovici, B. Kantarci, M. Erol-Kantarci, "RL meets Multi-Link Operation in IEEE 802.11be: Multi-Headed Recurrent Soft-Actor Critic-based Traffic Allocation," IEEE International Conference on Communications (ICC), 2023',
            link: ''
        },
        {
            title: 'IEEE Communications Society Distinguished Lecturer',
            date: '2023-2024',
            text: '',
            link: ''
        },
        {
            title: '48th WWRF Best Paper Award',
            date: '2022',
            text: 'O. M. Gul, M. Kulhandjian, B. Kantarci, A. Touazi, C. D’Amours, C. Ellement, “On the Impact of CDL and TDL Augmentation for RF Fingerprinting under Impaired Channels” 48th Wireless World Research Forum',
            link: ''
        },
        {
            title: 'IEEE Systems Council Distinguished Lecturer',
            date: '2022-2024',
            text: '',
            link: ''
        },
        {
            title: 'Ontario Minister of Colleges and Universities’ Award of Excellence',
            date: '2022',
            text: 'Category: Innovation and Entrepreneurship in 2020-2021',
            link: ''
        },
        {
            title: 'Full Member, Sigma Xi, The Scientific Research Honor Society (∑Ξ)',
            date: '2022',
            text: '',
            link: ''
        },
        {
            title: 'IEEE Globecom 2021 Best Paper Award',
            date: '2021',
            text: 'Z. Chen, M. Simsek, B. Kantarci, P. Djukic, "All Predict Wisest Decides: A Novel Ensemble Method to Detect Intrusive Traffic in IoT Networks” IEEE Global Communications Conference (Globecom 2021) –Communication QoS and Reliability Modeling Symposium.',
            link: ''
        },
        {
            title: 'Featured Profile (Ottawa Business Journal)',
            date: '2021',
            text: 'Creating ‘water cooler moments’ to drive connected car innovation in Kanata North 27 September 2021',
            link: 'https://obj.ca/article/Faculty-engineering-sponsored-creating-water-cooler-moments-drive-connected-car-innovation-kanata-north'
        },
        {
            title: 'ACM Senior Membership',
            date: '2020',
            text: '',
            link: ''
        },
        {
            title: 'Awardee of John Evans Leader’s Fund by Canada Foundation for Innovation',
            date: '2020',
            text: '',
            link: ''
        },
        {
            title: 'Outstanding  Thesis Prize Nomination: Graduate student Ji Chu Jiang',
            date: '2020',
            text: 'Supervised Thesis Title: High Precision Deep Learning-based Tabular Data Extraction',
            link: ''
        },
        {
            title: 'Outstanding Leadership Award from IEEE ICNC as Symposium Co-Chair: Machine Learning for Communications and Networking',
            date: '2020',
            text: '',
            link: ''
        },
        {
            title: 'ACM Distinguished Speaker',
            date: '2019-2021',
            text: '',
            link: ''
        },
        {
            title: 'Featured Profile (Ottawa Business Journal)',
            date: '2019',
            text: '“uOttawa Kanata North ramping up Smart Connected Vehicles Innovation Lab”18 Dec. 2020',
            link: 'https://obj.ca/index.php/article/faculty-of-engineering-sponsored-uottawa-kanata-north-ramping-smart-connected-vehicles-innovation-lab?fbclid=IwAR1msvMnz8uAd_ufB34MZ6AL-stvvkdl7X9ng7IcfoapVAYiwmNqyyb0gc0'
        },
        {
            title: 'Fall Cognos Prize (2nd Place) won by Student: Xuankai Chen.',
            date: '2019',
            text: 'Supervised Project: Artificial Neural Networks-assisted Data Acquisition in Mobile Crowdsensing Systems',
            link: ''
        },
        {
            title: 'Certificate of Appreciation for IEEE 7th IEEE International Conference on Wireless for Space and Extreme Environments as Publicity Co-Chair',
            date: '2019',
            text: '',
            link: ''
        },
        {
            title: 'Winter Cognos Prize won by Student: Mark Traquair',
            date: '2019',
            text: 'Supervised Project: Feasibility Study of Methods in Content Extraction From Tabular Data in Digitized Documents',
            link: ''
        },
        {
            title: 'Featured Profile (Ottawa Business Journal)',
            date: '2019',
            text: '“In search of safer cities, University of Ottawa researchers eye new uses for big data and vehicular crowd-sensing” 24 June 2019',
            link: 'https://obj.ca/article/uottawa-engineering-search-safer-cities-university-ottawa-researchers-eye-new-uses-big-data-and-vehicular-crowd'
        },
        {
            title: 'Outstanding Master’s Thesis Prize Nomination: Graduate student Cem Kaptan',
            date: '2018',
            text: 'Supervised Thesis Title: Data Analytics-backed Vehicular Crowd-sensing for GPS-less Tracking in Public Transportation',
            link: ''
        },
        {
            title: 'Appreciation Award from IEEE ComSoc as Technical Program Co-Chair of IEEE BlackSeaCom 2020',
            date: '2020',
            text: '',
            link: ''
        },
        {
            title: 'Certificate of Appreciation from IEEE Access as Guest editor of Special Section on Advances in Vehicular Clouds',
            date: '2017',
            text: '',
            link: ''
        },
        {
            title: 'Appreciation from IEEE Computer Society as Technical Program Co-Chair ISCC 2016',
            date: '2016',
            text: '',
            link: ''
        },
        {
            title: 'Appreciation from IEEE ComSoc as General Co-Chair IEEE CAMAD 2016',
            date: '2016',
            text: '',
            link: ''
        },
        {
            title: 'Best Paper Award at 12th HONET Conference',
            date: '2015',
            text: '',
            link: ''
        },
        {
            title: 'Certificate of Appreciation from IEEE International Cloud Networking (CLOUDNET) Conference as Technical Program Co-Chair',
            date: '2015',
            text: '',
            link: ''
        },
        {
            title: 'Certificate of Appreciation from IEEE International Cloud Networking (CLOUDNET) Conference as Publicity Co-Chair',
            date: '2014',
            text: '',
            link: ''
        },
        {
            title: 'IEEE Senior Membership',
            date: '2012',
            text: '',
            link: ''
        },


    ];